import { render, staticRenderFns } from "./ContactBatchUpdated.vue?vue&type=template&id=3ff94da2"
import script from "./ContactBatchUpdated.vue?vue&type=script&lang=js"
export * from "./ContactBatchUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports